// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import store from './store/index.js'
import router from './router/index.js'
import utils from '@/utils/base.js'
import Plugins from '@/plugins/index.js'
import Element  from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import VideoPlayer from 'vue-video-player';

Vue.config.productionTip = false
Vue.prototype.utils = utils
import CKEditor from '@ckeditor/ckeditor5-vue';

require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')
Vue.use(VideoPlayer);
Vue.use(CKEditor );
Vue.use(Plugins);
Vue.use(Element);

new Vue({
  el: '#app',
  render: h => h(App),
  router,
  store,
  components: { App },
  template: '<App/>'
})

